import React from 'react'
import { LinkBtn, l } from '@manychat/manyui'

import { KnowledgeBaseLink } from 'common/core/components/SupportLinks'
import { OfferStepTypes } from 'common/settings/components/SettingsPanel/BillingInfoProducts/CancelSubscriptionModal/types'
import { analyticsService } from 'utils/services/analytics'

import FacebookImg from './assets/facebook.png'

const PageProblems = () => {
  const handleClickVideo = () => {
    analyticsService.sendEvent(
      `SETTINGS.BILLING.CANCEL_MODAL.${OfferStepTypes.FACEBOOK_BLOCKED}.WATCH_VIDEO`,
    )
  }
  const handleClickArticle = () => {
    analyticsService.sendEvent(
      `SETTINGS.BILLING.CANCEL_MODAL.${OfferStepTypes.FACEBOOK_BLOCKED}.READ_ARTICLE`,
    )
  }
  const handleClickCommunity = () => {
    analyticsService.sendEvent(
      `SETTINGS.BILLING.CANCEL_MODAL.${OfferStepTypes.FACEBOOK_BLOCKED}.FACEBOOK_COMMUNITY`,
    )
  }

  return (
    <>
      <div className="p-a-lg">
        <h1 className="m-b-lg">{l.translate('Your Facebook page get blocked? We’ve got tips.')}</h1>
        <div className="d-flex align-center panel bg-default p-a-md">
          <img
            src={FacebookImg}
            className="m-r-xl d-none md-d-block"
            style={{ maxWidth: 159, maxHeight: 105 }}
          />
          <div>
            <h3>{l.translate('What to Do If You Get Blocked by Facebook')}</h3>
            <p className="m-b-md">
              {l.translate(
                'We have a guide with all the necessary steps you need to take to unblock your account, get back into good standings, and prevent future blocks.',
              )}
            </p>
            <div className="d-flex align-center">
              <LinkBtn
                target="_blank"
                href="https://manychat.com/resources/video-course/understanding-facebooks-24-hour-rule-and-re-engagement-rules/what-to-do-if-you-get-blocked-by-facebook"
                onClick={handleClickVideo}
                size="small"
                variant="primary"
              >
                {l.translate('Watch video')}
              </LinkBtn>
              <a
                onClick={handleClickArticle}
                className="text-primary m-l-md"
                href={`${KnowledgeBaseLink.FB_BLOCKED}#:~:text=Most%20Common%20Reasons%20Why%20The%20Page%20Got%20Blocked&text=To%20learn%20more%20about%20the,any%20kind%20of%20%22sale%22`}
                target="_blank"
                rel="noreferrer noopener"
              >
                {l.translate('Read support article')}
              </a>
            </div>
          </div>
        </div>
        <p className="text-secondary m-b-lg">
          {l.translate(
            'Also we have Manychat Community where you can get help and ask anything you’re worried about, including Facebook bans issues.',
          )}
        </p>
        <a
          onClick={handleClickCommunity}
          className="text-primary"
          href="https://community.manychat.com/"
          target="_blank"
          rel="noreferrer noopener"
        >
          {l.translate('Check out Manychat Community')}
        </a>
      </div>
    </>
  )
}

export default PageProblems
